import pathConstants from '../constants/pathConstants'

const pathUtils = {
  getContextPath: function (path) {
    let getContextPath = window['getContextPath']
    path = path || ''
    if (getContextPath) {
      return getContextPath() + path
    } else {
      return path
    }
  },
  isProtectedUrl: function (url) {
    return url && url.startsWith(pathConstants.PRO_RESOURCE_PREFIX)
  }
}

export default pathUtils



// WEBPACK FOOTER //
// ./src/util/pathUtils.js